<template>
  <PrivacyPolicy />
  <FileReport />
</template>

<script setup lang="ts">
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import FileReport from "@/components/FileReport.vue";
</script>
